/* eslint-disable no-restricted-imports */
import React, {useEffect, useMemo} from "react";
import { Modal} from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  AEInput,
  ModalProgressBar, Pagination
} from "../../../../_metronic/_partials/controls";
import { useModuleContext } from "../ModuleContext";
import {AEButton} from "../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import {actionTypes} from "../../Teams/_redux/slice";
import * as actions from "../../Teams/_redux/actions";
import { HTTP_UPDATED} from "../../../../_emywork/helpers/AxiosHelpers";
import {useIntl} from "react-intl";
import {useMetadata} from "../../../../_emywork/AEPagination";
import {AELabel} from "../../../../_emywork/components/AELabel";


export function AddToTeamModal() {
  const UIContext = useModuleContext();
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();

  const {authUser, teams, teamsLoading,teamsMeta} = useSelector( (s) => {
    const {entities: teams, isLoading:teamsLoading, meta: teamsMeta} = s.teams[actionTypes.AddToTeamModalList];
    const {user: authUser} = s.auth;

    return { authUser, teams, teamsLoading, teamsMeta }
  }, shallowEqual );

  const metadata = useMetadata(teamsMeta);
  const { page, perPage, sortAsc, filters, sortField, select, setPerPage, setFilters, total } = metadata;
  const formik = useFormik({
    initialValues: {
      ...filters
    },
    onSubmit: (values)=>{
      setFilters(values)
    }
  });

  const {show, close, id} = useMemo(() => {
    return {
      show: UIContext.teamModalShow,
      close: UIContext.closeTeamDialog,
      id: UIContext.idForTeam,
    };
  }, [UIContext]);

  // looking for loading/dispatch
  useEffect(() => {
    if(id){
      let m = metadata.toAEMetadata();
      m.filters.user_id = authUser.id
      dispatch(
        actions.fetchEntities(m, actionTypes.AddToTeamModalList)
      )
    }

  }, [id, authUser, dispatch, filters, page, perPage,]);

  useEffect(() => {
    formik.handleSubmit()
  }, [formik.values.search]);



  return (
    <Modal size={'lg'} show={show} onHide={close} >
      {teamsLoading && <ModalProgressBar variant="query" />}
      <Modal.Body>
        <div className="font-weight-bold h5 pb-4">
          {formatMessage({id:"TEAMS"})}
        </div>
        <AEInput
          borderless
          validation={false}
          withFeedbackLabel={false}
          className={"form-control-solid"}
          field={formik.getFieldProps('search')}
          form={formik}
          name={"search"}
          label={"SEARCH"}
        />

        <div
          className="mt-7 scroll scroll-pull"
          // style={{maxHeight: 400}}
        >
          {
            !teamsLoading &&
            teams.map(team=>{
              const isTeamMember = team.members.findIndex(member=>member.id === id);
              return (
                <div key={team.id} className="d-flex align-items-center -justify-content-between mb-5">
                  <div className="d-flex align-items-center">
                    <div className={`symbol symbol-circle symbol-40 mr-3`}>
                        <span className="symbol-label">
                          {team.name[0]}
                        </span>
                      {/*<img alt="Pic" src={toAbsoluteUrl(`/media/users/300_13.jpg`)}/>*/}
                    </div>
                  </div>
                  <div className="d-flex flex-column">
                    <a
                      href="#"
                      className="text-dark-75 text-hover-primary font-weight-bold font-size-lg"
                      onClick={e=>{
                        e.preventDefault();
                        // setId(team.id);
                        dispatch(actions.updateEntity(
                          {
                            ...team,
                            members: [...team.members.map(member=>member.id), id]
                          }
                        ))
                          .then((r)=>{
                            if(r.status === HTTP_UPDATED) {
                              close()
                            }
                          })
                      }
                      }
                    >
                      {team.name}
                    </a>
                    <span className="text-muted font-weight-bold font-size-sm">
                        {
                          isTeamMember !== -1 &&
                          <AELabel >
                            {formatMessage({id:'MEMBER'})}
                          </AELabel>
                        }
                      </span>
                  </div>


                </div>
              )
            })

          }

          <Pagination {...metadata} className={''}/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <AEButton variant={'light'} onClick={close} >
          {formatMessage({id:"DONE"})}
        </AEButton>
      </Modal.Footer>
    </Modal>
  );
}
